import React from 'react';
import Meta from 'project/containers/meta';
import Tour from 'project/containers/wrapup/tour';

const Intro = () => (
  <div className="wrapup">
    <Meta title="Wrap-up" />
    <Tour />
  </div>
);

export default Intro;



// WEBPACK FOOTER //
// ./project/components/wrapup/intro.jsx